// Display-only pilot scope; not an authorization decision.
// The Novel backend independently requires exact saved Story _id and ownership.
export function finalPrintPilotAvailableForBook({
  enabled = false,
  pilotStoryId = "",
  canonicalStoryId = "",
  storyType = "",
  isOwner = false,
} = {}) {
  const id = String(pilotStoryId ?? "").trim().toLowerCase();
  const savedId = String(canonicalStoryId ?? "").trim().toLowerCase();
  return enabled === true &&
    isOwner === true &&
    /^[a-f0-9]{24}$/.test(id) &&
    id === savedId &&
    String(storyType ?? "").trim().toLowerCase() === "longform";
}
